import type { Kiosk } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchCheckinKiosks = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<Kiosk[]>(`/stores/${storeId}/checkins`)
  return response.data
}
